import { render, staticRenderFns } from "./IncxWindows.vue?vue&type=template&id=c288e39a&"
import script from "./IncxWindows.vue?vue&type=script&lang=js&"
export * from "./IncxWindows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports